import { useContext } from 'react'
import { Grid } from '@mui/material'
import EnergyFlow from '../energy-flow/energyFlow'
import DashboardUsageCards from '../cards/usageCardLayout'
import CarbonTrack from './carbonTrack'
import SystemError from './systemError'
import NewAccount from './newAccount'
import EmuBanner from './emuBanner'
import { DataContext } from '../../../contexts/data/dataContext'

export default function CustomerDashboard() {
  const data = useContext(DataContext)
  
  const energyFlow = (
          <Grid item xs width="100%" >
            <EnergyFlow />
          </Grid>
  )
  const dashboardUsage = (
          <Grid item xs width="100%" >
            <DashboardUsageCards />
          </Grid>
  )
  const isCarbonTrack = (
    <Grid item xs width="100%" >
      <CarbonTrack />
    </Grid>
  )
  const isEmu = (
    <Grid item xs width="100%" >
      <EmuBanner />
    </Grid>
  )
  const isNewAccount = (
    <Grid item xs width="100%" mx={1}>
      <NewAccount />
    </Grid>
  )
  const systemError = (
    <Grid item xs width="100%" >
      <SystemError />
    </Grid>
  )

  return (
      <Grid item xs width="100%" >   
        {data?.customer?.hasUsageData===true && energyFlow}
        {data?.customer?.hasUsageData===true && dashboardUsage}
        {data?.customer?.isEMU===true 
            && data?.customer?.hasUsageData===false
            && isEmu}
        {data?.customer?.isCarbonTrack===true 
            && data?.customer?.hasUsageData===false
            && isCarbonTrack}
        {data?.customer?.isNewAccount===true 
            && data?.customer?.hasUsageData===false
            && isNewAccount}
        {data?.customer?.isCarbonTrack===false &&
          data?.customer?.isNewAccount===false &&
          data?.customer?.isEMU===false &&
          data?.customer?.hasUsageData===false && systemError}
      </Grid>   
  )
}
